<template>
  <div class="differentiating-benefits-brazilianity-content" id="plataforma-de-marca-beneficios-diferenciadores-brasilidade" data-search-anchor>
    <div class="differentiating-benefits-brazilianity-overlay-title-image">
      <h1 class="differentiating-benefits-brazilianity-image-brazilianity-title" style="margin-top: 4rem;">
        {{ differentiatingBenefitsBrazilianityImageTitle }}
      </h1>
      <h1 class="differentiating-benefits-brazilianity-image-brazilianity-title" style="margin-bottom: 2rem;">
        {{ differentiatingBenefitsBrazilianityImageTitle2 }}
      </h1>
      <p class="differentiating-benefits-brazilianity-image-brazilianity-text">
        {{ differentiatingBenefitsBrazilianityImageTitle3 }}
      </p>
    </div>

    <div
      class="differentiating-benefits-brazilianity-banner-image"
      :style="{ backgroundImage: `url(${differentiatingBenefitsBrazilianityImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import DifferentiatingBenefitsPageMixin from '@/mixins/differentiating-benefits-page-mixin'
import { DifferentiatingBenefitsPageStore } from '@/store/brand-plataform-page/differentiating-benefits-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class DifferentiatingBenefitsBrazilianitySection extends Mixins(
  DifferentiatingBenefitsPageMixin
) {
  differentiatingBenefitsPageStore: PageStoreContract = getModule(
    DifferentiatingBenefitsPageStore,
    this.$store
  )

  get differentiatingBenefitsBrazilianityImageTitle(): string {
    return this.getElementText(3, 0)
  }

  get differentiatingBenefitsBrazilianityImageSrc(): string {
    return this.getElementMedia(3, 0)
  }

  get differentiatingBenefitsBrazilianityImageTitle2(): string {
    return this.getElementText(3, 1)
  }

  get differentiatingBenefitsBrazilianityImageTitle3(): string {
    return this.getElementText(3, 2)
  }

  async getDifferentiatingBenefitsPageStore(): Promise<void> {
    await this.differentiatingBenefitsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.differentiatingBenefitsPageStore.isLoading) {
      await this.getDifferentiatingBenefitsPageStore()
    }
  }
}
</script>

<style lang="scss">
.differentiating-benefits-brazilianity-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;    
}

.differentiating-benefits-brazilianity-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.differentiating-benefits-brazilianity-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.differentiating-benefits-brazilianity-image-brazilianity-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.differentiating-benefits-brazilianity-image-brazilianity-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
